<template>
<div class="" style="margin-top:10px;padding-top:0px;" >


  <div class="row pad-in yo-bg-color-tertiary" style="padding-top:12px;border-bottom:3px solid #379EC2;">
    
    <div class="col m1m yo-hidden-phone">&#160;</div>
    <div class="col s12 m9 ">

        <div v-if="$teras.evento.sottotitolo==''" class="yo-text-xxl yo-text-bold yo-spacing-s black " style="overflow:hidden;" @click="screenshot()">{{$teras.evento.titolo}}</div>
        <div v-if="$teras.evento.sottotitolo!=''" class="yo-text-xl yo-text-bold yo-spacing-s black " style="overflow:hidden;" @click="screenshot()">{{$teras.evento.titolo}}</div>
        <div v-if="$teras.evento.sottotitolo!=''" class="yo-text-m" style="overflow:hidden;" @click="screenshot()">{{$teras.evento.sottotitolo}}</div>
        <!-- commentata il 17-10-2018 perchè dava errore in IE 11, bisogna capire se serve o meno
        <img :src="pngFrom" style="width:500px;"  />
        -->
    </div>
    <div class="col s5 m1m yo-align-center yo-valign-text-center " style="height:100px;">
      <div class="yo-bg-cover" style="height:100%;width:100%;" v-if="$teras.evento.provider>0 && $teras.evento.imglogo==''" :style="{'background-image': `url(${require('../assets/provider_'+$teras.evento.provider+'.png')})`}"></div>
      <div class="yo-bg-cover" style="height:100%;width:100%;" v-if="$teras.evento.imglogo!=''" :style="{'background-image': 'url('+$teras.bventUrl+$teras.evento.id+'/'+$teras.evento.imglogo+')'}"></div>
    </div>
    
    

    <div class="col s7 m8 offset-m1m">
        <div class="row yo-text-n yo-text-bold yo-spacing-s black" style="">{{$teras.evento.citta}}</div>
        <div class="row yo-text-n yo-text-bold yo-spacing-s black" v-if="$teras.evento.iniziail==$teras.evento.finisceil">{{$teras.evento.finisceil | data('DD MMMM YYYY')}}</div>
        <div class="row yo-text-n yo-text-bold yo-spacing-s black" v-if="$teras.evento.iniziail!=$teras.evento.finisceil">{{$teras.evento.iniziail | data('DD MMMM')}} - {{$teras.evento.finisceil | data('DD MMMM YYYY')}}</div>
        
        <div class="row yo-text-n yo-text-bold yo-spacing-s black" style="margin:30px 0 20px 0;">{{$lang.g('responsabileScientifico')}}:<br />{{$teras.evento.respscientifico}}</div>
    </div>


  </div>

  <!-- fine top -->


   <div class="row pad-in yo-bg-color-tertiary" style="border-bottom:6px solid #379EC2;">
      <div class="col s12 m1m social-vmenu " style="" :class="'social-vmenu-'+$teras.app.device">
      <a :href="'https://www.facebook.com/sharer.php?u=http://www.biomedia.net/facebook/'+$teras.evento.id+'.html'" target="_blank"><img src="../assets/facebook.png" /></a>
      <a :href="'https://twitter.com/share?url=https://next.biomedia.net/evento-home/'+$teras.evento.id+'&via=biomedia&text='+$teras.evento.titolo" target="_blank"><img src="../assets/twitter.png" /></a>
      <a :href="'whatsapp://send?text=https://next.biomedia.net/evento-home/'+$teras.evento.id"><img src="../assets/whatsapp.png" /></a>
      </div>
      
      <div v-if="side==''" class="col s12 m5 " style="" :style="{'padding-top': $teras.app.device!='mobile' ? '34px' : '10px'}">
        <div class="" style="width:100%;height:320px;">
          <div class="yo-bg-cover" style="height:100%;width:100%;border:2px solid #379EC2;" :style="{'background-image': 'url('+$teras.bventUrl+$teras.evento.id+'/'+$teras.evento.imgcitta+')'}"></div>
        </div>



         <div class="row yo-bg-color-secondary white ">

            <div class="col s12 m6 yo-align-right yo-text-n yo-text-bold" style="line-height:40px;">
              <div v-if="$teras.evento.provider>0" class="white">
                <div class="bolle" style="float:left;width:70px;height:40px;" :style="{'background-image': `url(${require('../assets/bolle.png')})`}">&#160;</div> 
                <div class="yo-text-s yo-text-bold" style="float:left;line-height:40px;">PROVIDER {{$teras.evento.providernome}} N. {{$teras.evento.providernumero}}</div>
              </div>
              <div v-else>&#160;</div>

            </div>

            <div v-if="$teras.evento.crediti>0" class="col s12 m5x yo-align-right yo-text-n yo-text-bold" style="line-height:40px;">
               <div style="height:40px;float:right;">{{$teras.evento.crediti}} {{$lang.g('creditiEcm')}}</div>
               <div class="bolle" style="float:right;width:70px;height:40px;" :style="{'background-image': `url(${require('../assets/bolle.png')})`}">&#160;</div>
            </div>
               
         </div>

      </div>

      <div v-if="side=='iscrizioni'" class="col s12 m5 " style="" :style="{'padding-top': $teras.app.device!='mobile' ? '34px' : '10px'}">
        <div class="" style="background:lightgrey;padding:10px;border:2px solid #379EC2;min-height:326px;">
        
            ssss
        
        </div>
        <div @click="side=''" class="yo-pointer yo-bg-color-secondary yo-block white yo-align-center yo-text-l" style="height:36px;line-height:36px;">CHIUDI</div>
      </div>


      <div class="col s12 m5 offset-mm " style="padding-top:34px;">
          <div v-if="show=='' && $teras.moment().isSameOrBefore($teras.evento.finisceil+' 23:59:00')" class="row yo-align-left yo-text-xxl yo-text-bold yo-color-secondary" style="width:100%;height:54px;margin-bottom:30px;">
              <div class="col s7">
                <div class="row yo-text-xl yo-text-bold yo-spacing-s black" style="">{{$teras.evento['tpsetitolo'+$teras.lang]}}</div>
                <div class="row yo-text-n yo-text-bold yo-spacing-s black" v-html="$teras.evento['tpsemore'+$teras.lang]"></div>
              </div>
              <div class="col s5" v-if="$teras.evento.tpsetipo == 1"><div class="yo-bg-color-secondary yo-block white yo-align-center yo-text-l" style="background:#ED002E;height:36px;line-height:36px;">{{$teras.evento['tpsenome'+$teras.lang]}}</div></div>
              <div class="col s5" v-if="$teras.evento.tpsetipo == 2"><div @click="dialogIscrizioni=true" class="yo-pointer yo-block white yo-align-center yo-text-l" style="background:#016000;height:36px;line-height:36px;">{{$teras.evento['tpsenome'+$teras.lang]}}</div></div>
              <div class="col s5" v-if="$teras.evento.tpsetipo == 3"><div class="yo-bg-color-secondary yo-block white yo-align-center yo-text-l" style="height:36px;line-height:36px;">{{$teras.evento['tpsenome'+$teras.lang]}}</div></div>
              <div class="col s5" v-if="$teras.evento.tpsetipo == 4">
                <el-popover :ref="'evento-'+$teras.evento.id" placement="top-start" width="400" trigger="click">
                  <div class="yo-pointer yo-bg-color-secondary yo-block white yo-align-center yo-text-l" style="height:36px;line-height:36px;" slot="reference">{{$teras.evento['tpsenome'+$teras.lang]}}</div>
                  <div class="info">
                    Siamo spiacenti ma a causa del raggiungimento della capacità massima della sala le iscrizioni sono chiuse.
                    <br /><br />
                    Non sono previste liste di attesa o iscrizioni per uditori 
                  </div>
                </el-popover>
              
                <!--
                  <div @click="show='eventochiuso'" class="yo-pointer yo-bg-color-secondary yo-block white yo-align-center yo-text-l" style="height:36px;line-height:36px;">{{$teras.evento.tpsenome}}</div>
                -->
              </div>
                      
          </div>
          <div v-else class="row yo-align-left yo-text-xxl yo-text-bold yo-color-secondary" style="width:100%;height:54px;margin-bottom:30px;">
            <div class="col s5 offset-s7" ><div class="yo-bg-color-secondary yo-block white yo-align-center yo-text-l" style="height:36px;line-height:36px;">Evento concluso</div></div>
          </div>


          <el-dialog  :visible.sync="dialogIscrizioni" :fullscreen="false" width="80%" top="5vh">
            <div class="title_h1 yo-color-secondary">{{$lang.g('leQuote')}}:</div>


            
            <div v-if="$teras.lang=='it'">
            <div v-if="$teras.evento.htmlquote!=''" v-html="$teras.evento.htmlquote"> </div>
            <div v-else class="row vpad pad" v-for="item in quota" :key="item.id" style="border-bottom:1px solid grey;">
              <div class="col s6 m8"><strong>{{item.nome}}</strong><div v-if="item.descrizione!=''">{{item.descrizione}}</div></div>
              <div class="col s6 m4 yo-align-right">
                {{item.importo | money('€ ')}}+iva = {{item.importoivato}}
                <div v-if="item.ridottafinoal!='0000-00-00'">Fino a al {{item.ridottafinoal | data('DD-MM-YYYY')}} {{item.ridottaimporto | money('€ ')}}+iva = {{item.ridottaimportoivato}}</div>
              </div>
            </div>
            </div>

            <div v-if="$teras.lang=='en'">
            <div v-if="$teras.evento.htmlquoteeng!=''" v-html="$teras.evento.htmlquoteeng"> </div>
            <div v-else class="row vpad pad" v-for="item in quota" :key="item.id" style="border-bottom:1px solid grey;">
              <div class="col s6 m8"><strong>{{item.nome}}</strong><div v-if="item.descrizione!=''">{{item.descrizione}}</div></div>
              <div class="col s6 m4 yo-align-right">
                {{item.importo | money('€ ')}}+VAT = {{item.importoivato}}
                <div v-if="item.ridottafinoal!='0000-00-00'">Fino a al {{item.ridottafinoal | data('DD-MM-YYYY')}} {{item.ridottaimporto | money('€ ')}}+VAT = {{item.ridottaimportoivato}}</div>
              </div>
            </div>
            <!-- <div v-else>{{$lang.g('infoPrestoDisponibili')}}</div> -->
            </div>

            <br />
            <div v-if="$teras.lang=='it'" v-html="$teras.evento.htmlinfo"> </div>
            <div v-if="$teras.lang=='en'" v-html="$teras.evento.htmlinfoeng"> </div>

            <div v-if="$teras.evento.id==3012 && $teras.moment().isSameOrBefore($teras.evento.finisceil)" class="row pad" style="margin-top:40px;">
              <a :href="'https://bvent.biomedia.net/s/2797?lang='+($teras.lang=='it'?'ita':'eng')">
              <div  class="col s6 m4 offset-m1 yo-pointer yo-bg-color-secondary yo-block white yo-align-center yo-text-n" style="height:36px;line-height:36px;">{{$lang.g('iscriviti')}}</div>
              </a>
              <a  v-if="$teras.evento.apertoaziende==1" :href="'https://bvent.biomedia.net/c/2797?lang='+($teras.lang=='it'?'ita':'eng')">
              <div  class="col s6 m4 offset-m2 yo-pointer yo-bg-color-secondary yo-block white yo-align-center yo-text-n" style="height:36px;line-height:36px;">{{$lang.g('iscrizioniAziende')}}</div>
              </a>
            </div>

            <div v-if="$teras.evento.id!=3012 && $teras.moment().isSameOrBefore($teras.evento.finisceil+' 23:59:00')" class="row pad" style="margin-top:40px;" >
            <!--
              <div @click="dialogIscrizioni=false" class="col s4 yo-pointer yo-bg-color-secondary yo-block white yo-align-center yo-text-l" style="height:36px;line-height:36px;">CHIUDI</div>
              -->
              <a :href="'https://bvent.biomedia.net/s/'+$teras.evento.id+'?lang='+($teras.lang=='it'?'ita':'eng')">
              <div  class="col s6 m4 offset-m1 yo-pointer yo-bg-color-secondary yo-block white yo-align-center yo-text-n" style="height:36px;line-height:36px;">{{$lang.g('iscriviti')}}</div>
              </a>
              <a  v-if="$teras.evento.apertoaziende==1" :href="'https://bvent.biomedia.net/c/'+$teras.evento.id+'?lang='+($teras.lang=='it'?'ita':'eng')">
              <div  class="col s6 m4 offset-m2 yo-pointer yo-bg-color-secondary yo-block white yo-align-center yo-text-n" style="height:36px;line-height:36px;">{{$lang.g('iscrizioniAziende')}}</div>
              </a>
            </div>
            
<!--
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogIscrizioni=false">Chiudi</el-button>
            </span>
            -->
          </el-dialog>




          <div v-if="show=='iscrizioni'" class="" style="margin-bottom:30px;">
            <div class="" style="background:lightgrey;padding:10px;border:2px solid #379EC2;min-height:326px;">
            
            
            
            
            </div>
            <div @click="show=''" class="yo-pointer yo-bg-color-secondary yo-block white yo-align-center yo-text-l" style="height:36px;line-height:36px;">CHIUDI</div>
          </div>

          <div v-if="show=='eventochiuso'"  class="" style="margin-bottom:30px;">
            <div class="yo-text-l" style="background:lightgrey;padding:10px;border:2px solid #379EC2;min-height:326px;">
            Siamo spiacenti ma a causa del raggiungimento della capacità massima della sala le iscrizioni sono chiuse.
            <br /><br />
            Non sono previste liste di attesa o iscrizioni per uditori
            </div>
            <div @click="show=''" class="yo-pointer yo-bg-color-secondary yo-block white yo-align-center yo-text-l" style="height:36px;line-height:36px;">CHIUDI</div>
          </div>
          
          <div v-if="show==''" class="" style="">

            <div class="yo-align-left yo-text-s yo-text-bold black" style="width:100%;line-height:18px;">
            {{$lang.g('referenteBiomedia')}}<br />{{$teras.evento.responsabile}}<br /><a :href="'mailto:'+$teras.evento.responsabileemail">{{$teras.evento.responsabileemail}}</a>
            </div>


            <div class="yo-valign-text-bottom yo-color-secondary" style="width:100%;height:224px;margin-bottom:30px;">

                <a v-if="$teras.evento.personalizzatolink!=''" :href="$teras.evento.personalizzatolink" target="_blank" class="clear black yo-text-s yo-text-bold">
                  <div class="bolle yo-bg-color-secondary" style="float:left;width:50px;height:26px;" :style="{'background-image': `url(${require('../assets/bolle.png')})`}">&#160;</div>
                  <div style="float:left;line-height:26px;padding-left:8px;">{{$teras.evento.personalizzatolabel}}</div>
                </a>


                <a v-if="$teras.evento.linkprogramma!=''" :href="$teras.bventUrl+$teras.evento.id+'/'+$teras.evento.linkprogramma+'?'+$teras.random()" target="_blank" class="clear black yo-text-s yo-text-bold" style="margin-top:12px;">
                  <div class="bolle yo-bg-color-secondary" style="float:left;width:50px;height:26px;" :style="{'background-image': `url(${require('../assets/bolle.png')})`}">&#160;</div>
                  <div style="float:left;line-height:26px;padding-left:8px;">{{$lang.g('programma')}}</div>
                </a>

                <a v-if="$teras.evento.abslink==2" :href="'https://api.biomedia.net/bams/start/'+$teras.evento.abs" target="_blank" class="clear black yo-text-s yo-text-bold" style="margin-top:12px;">
                  <div class="bolle yo-bg-color-secondary" style="float:left;width:50px;height:26px;" :style="{'background-image': `url(${require('../assets/bolle.png')})`}">&#160;</div>
                  <div style="float:left;line-height:26px;padding-left:8px;">ABSTRACT</div>
                </a>
                <a v-if="$teras.evento.abslink==3" :href="'https://api.biomedia.net/bams/startconsulta/'+$teras.evento.abs" target="_blank" class="clear black yo-text-s yo-text-bold" style="margin-top:12px;">
                  <div class="bolle yo-bg-color-secondary" style="float:left;width:50px;height:26px;" :style="{'background-image': `url(${require('../assets/bolle.png')})`}">&#160;</div>
                  <div style="float:left;line-height:26px;padding-left:8px;">ABSTRACT</div>
                </a>







                <a v-if="$teras.evento.tpsetipo == 2" @click="dialogIscrizioni=true" href="#!" class="clear black yo-text-s yo-text-bold" style="margin-top:12px;">
                  <div class="bolle yo-bg-color-secondary" style="float:left;width:50px;height:26px;" :style="{'background-image': `url(${require('../assets/bolle.png')})`}">&#160;</div>
                  <div style="float:left;line-height:26px;padding-left:8px;">{{$lang.g('modalitaIscrizione')}}</div>
                </a>

                <!--
                <a v-if="$teras.evento.emailprenotazioni!=''" :href="'mailto:'+$teras.evento.emailprenotazioni" class="clear black yo-text-s yo-text-bold" style="margin-top:12px;">
                  <div class="bolle yo-bg-color-secondary" style="float:left;width:50px;height:26px;" :style="{'background-image': `url(${require('../assets/bolle.png')})`}">&#160;</div>
                  <div style="float:left;line-height:26px;padding-left:8px;">PRENOTAZIONE ALBERGHIERA E VIAGGIO</div>
                </a>
                -->

                <div v-if="$teras.evento.emailprenotazioni!=''" class="clear yo-pointer black yo-text-s yo-text-bold" style="margin-top:12px;">
                  <el-popover :ref="'evento-'+$teras.evento.id" placement="top-start" width="400" trigger="click">
                    <div slot="reference">
                      <div class="bolle yo-bg-color-secondary" style="float:left;width:50px;height:26px;" :style="{'background-image': `url(${require('../assets/bolle.png')})`}">&#160;</div>
                      <div style="float:left;line-height:26px;padding-left:8px;">{{$lang.g('prenotazioneAlberghiera')}}</div>
                    </div>
                    <div class="info" v-html="$teras.evento.emailprenotazioni"></div>
                  </el-popover>
                </div>


                <a v-if="$teras.evento.linkgalleria!=''" :href="$teras.evento.linkgalleria" target="_blank" class="clear black yo-text-s yo-text-bold" style="margin-top:12px;">
                  <div class="bolle yo-bg-color-secondary" style="float:left;width:50px;height:26px;" :style="{'background-image': `url(${require('../assets/bolle.png')})`}">&#160;</div>
                  <div style="float:left;line-height:26px;padding-left:8px;" >{{$lang.g('visualizzaGallery')}}</div>
                </a>
            
            </div>
          </div>
      
      </div>
   </div>


   <!-- TESTO ISCRIZIONI -->
<!--
   <div class="title_h1 yo-color-secondary">LE QUOTE DI ISCRIZIONI SONO LE SEGUENTI:</div>
<p><strong>XXXXXX</strong> <br />XXXXXX <br /><br /></p>
<div class="title_h1 yo-color-secondary">REGOLAMENTO ISCRIZIONI</div>
<p>​Per iscriversi al corso è attiva fino ad esaurimento posti il pulsante iscrizioni <br />Ad esaurimento posti disponibili la scheda di iscrizione online verrà sostituita con un messaggio di iscrizioni al completo, non sono previste liste d'attesa. <br /><br />La modalità sopra indicata è l'unica prevista, non potranno quindi essere accettate iscrizioni telefoniche, tramite fax e/o email. <br /><br /></p>
<div class="title_h1 yo-color-secondary">MODALITÀ DI PAGAMENTO</div>
<p>È possibile iscriversi effettuando il pagamento con:
<ul>
<li>carta di credito (transazione sicura con circuito Banca Sella) </li>
<li>bonifico online Mybank (transazione sicura con circuito Banca Sella)</li>
<li>bonifico bancario (i dati per effettuare il pagamento vengono inviati al termine dell’iscrizione)</li>
</ul>
Collegandosi alla piattaforma iscrizioni, dopo aver compilato i dati richiesti, il sistema in automatico visualizzerà l’importo e gli estremi del pagamento.<br /><br /><br /></p>
<div class="title_h1 yo-color-secondary">ESENZIONE IVA - FATTURE INTESTATE ALLA PUBBLICA AMMINISTRAZIONE</div>
<p>I partecipanti che necessitano di fattura intestata ad enti della Pubblica Amministrazione, devono registrarsi online inserendo il CODICE UNIVOCO AZIENDALE. <br />Il codice è fornito solo ed unicamente dall’ufficio di competenza della propria struttura di lavoro, senza tale codice non è possibile procedere con l'iscrizione. <br />Le iscrizioni con fattura intestate alla P.A. risultano immediatamente confermate e per il pagamento seguono i tempi previsti dagli Enti, pertanto i partecipanti non dovranno più anticipare la quota di iscrizione.<br /><br /><br /></p>
<div class="title_h1 yo-color-secondary">CANCELLAZIONI E RIMBORSI:</div>
<p>Per le rinunce che perverranno alla Segreteria Organizzativa fino a 20 giorni prima dell’inizio del corso verrà rimborsato il 50% della quota d’iscrizione. <br />Dopo tale data non è previsto alcun tipo di rimborso. Inoltre non saranno rimborsate quote di iscrizioni non usufruite, per le quali non sia pervenuta la relativa rinuncia entro i termini stabiliti. <br />In qualsiasi momento è comunque possibile sostituire il nominativo dell’iscritto.<br />Qualora l'evento venga cancellato per cause che non dipendano dalla Segreteria Organizzativa, la stessa non rimborserà spese sostenute dal partecipante ad eccezione della quota di iscrizione.</p>
-->

   <!-- WISC 2020 WEBINAR -->
   <wiscWebinar v-if="$teras.evento.id==2797 "></wiscWebinar>


   <!-- SEZIONE INTERESSE O RANDOM -->
   <eventiInteresse></eventiInteresse>

   <!-- SEZIONE AREE -->
   <aree></aree>


</div>
</template>

<script>
import eventiInteresse from '../components/Eventi-interesse'
import wiscWebinar from '../components/Wisc-webinar'
import aree from '../components/Aree'


export default {
  name: 'home',
  components: {
    eventiInteresse,
    aree,
    wiscWebinar
  },

  data () {
    return {
      dialogIscrizioni: false
      ,show:''  
      ,side:''
      ,pngFrom:'' 
      ,quota:[]
    }
  },
  /*
  metaInfo() {
    return {
      title: this.$teras.evento.titolo,
      //titleTemplate: '%s | My Awesome Webapp',
      meta: [
        { property: 'og:title', content: 'Dap studio a news for you' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ,{ 'http-equiv': 'refresh', content: 'https://next.biomedia.net/eventi/evento-home/'+ this.$teras.evento.id}

      ]
    }
  },
  */
   created () {
      this.$teras.page.title = "BioMedia - " + this.$teras.evento.titolo
      this.$teras.page.sezione = this.$lang.g('eventi')
      this.$lang.event.on('change', (lang) => {
          this.$teras.page.sezione = this.$lang.g('eventi')
      })
      
      

      //setTimeout(this.fetchData, 3000)
      this.fetchData()

   },
   watch: {
      '$route': 'fetchData'
   },
   methods: {
      fetchData () {
         console.log("CI PROVO "+this.$route.params.id)

        if(this.$route.params.id==3060)
          window.location.href = "https://siaip.congressonazionale.com/";

        if(this.$route.params.id==3019)
          window.location.href = "https://sinu.congressonazionale.com/";

        //alert(this.$route.params.id)
        if(this.$route.params.id==3050)
          window.location.href = "https://airmm.congressonazionale.com/";

        if(this.$route.params.id==2921)
          window.location.href = "https://www.biomedia.net/sinp2020/";


        if(this.$route.params.id==3043)
          window.location.href = "https://www.siaip.it/site/page/a/2559/Corsi%20FAD%20ECMXXII%20Congresso%20Nazionale%20SIAIP";

        if(this.$route.params.id==3040)
          window.location.href = "https://www.biomedia.net/pediacampus/";
          
        if(this.$route.params.id==2849)
          window.location.href = "https://sibioc.congressonazionale.com/";

        if(this.$route.params.id==2897)
          window.location.href = "https://fad.biomedia.net/start/20006";


        /*Rimosso su richiesta di matteo e galli il 14 ottobre 2020
        if(this.$route.params.id==2854)
          window.location.href = "https://sinu.congressonazionale.com/";
        */
        /*Rimesso su richiesta di matteo il2 1 ottobre 2020*/
        if(this.$route.params.id==2854)
          window.location.href = "https://sinu.congressonazionale.com/";
        

        if(this.$route.params.id==2850)
          window.location.href = "https://sigenp.congressonazionale.com/";

        if(this.$route.params.id==2858)
          window.location.href = "https://sigu.congressonazionale.com/";

        if(this.$route.params.id==2953)
          window.location.href = "https://fad.biomedia.net/start/20902";


        if(this.$route.params.id==2857)
          window.location.href = "https://airmm.congressonazionale.com/";

        if(this.$route.params.id==2848)
          window.location.href = "https://siaip.congressonazionale.com";
          
        if(this.$route.params.id==2684)
          window.location.href = "https://sinu.congressonazionale.com";

        if(this.$route.params.id==2597)
          window.location.href = "http://congressoairmm.biomedia.net/2019";
          
        if(this.$route.params.id==2560)
          window.location.href = "http://congresso.siaip.it/2019";
          
        if(this.$route.params.id==2525)
          window.location.href = "http://www.embacongress.it/2019";
          
        if(this.$route.params.id==2634)
          window.location.href = "http://congresso.sigu.net/2019";
          
        if(this.$route.params.id==2614)
          window.location.href = "http://congresso.sibioc.it/2019";
          
        if(this.$route.params.id==2386)
          window.location.href = "http://congresso.sigenp.org/";
          
        if(this.$route.params.id==2582)
          window.location.href = "http://congresso.sip.it/";
          
        if(this.$route.params.id==2612)
          window.location.href = "https://neonatologia.congressonazionale.com";
          
        if(this.$route.params.id==2613)
          window.location.href = "https://neurologiapediatrica.congressonazionale.com";
          
        if(this.$route.params.id==2186)
          window.location.href = "https://fad2014.biomedia.net/corso/index/corso/1902";


         

        if(this.$route.params.id==2354)
          window.location.href = "http://congresso.sip.it/2018";
          
        if(this.$route.params.id==2366)
          window.location.href = "http://congresso.neonatologia.it/2018";
        
        if(this.$route.params.id==2367)
          window.location.href = "http://congresso.neurologiapediatrica.it/2018";

        if(this.$route.params.id==2360)
          window.location.href = "http://congresso.sigenp.org/2018";

        if(this.$route.params.id==2361)
          window.location.href = "http://congresso.sibioc.it/2018";
          
        if(this.$route.params.id==2402)
          window.location.href = "http://congresso.sinepe.it/2018";
          
        if(this.$route.params.id==2367)
          window.location.href = "http://congresso.neurologiapediatrica.it/2018";
          
        if(this.$route.params.id==2362)
          window.location.href = "http://congresso.sigu.net/2018";

        if(this.$route.params.id==2426)
          window.location.href = "https://fad2014.biomedia.net/corso/index/corso/1889";
        

        if(this.$route.params.lang=='en' || (this.$route.params.id==2797 && this.$route.params.lang!='it') || (this.$route.params.id==3012 && this.$route.params.lang!='it')){
          this.$lang.change('en')
        }

        this.axios.query('fetchAll',`SELECT * FROM articolo WHERE tipoarticolo=1 AND visibile=1 AND evento=←evento ORDER BY nome`,{evento:this.$route.params.id},this,'quota')

        
          


         for (let item of this.$teras._evento){
            if(item.id == this.$route.params.id){
               this.$teras.evento = item 
               break
            }
         }
        this.$teras.page.title = "Biomedia - "+this.$teras.evento.titolo
        this.facebook(this.$teras.evento)      
      },
      facebook(page){
        this.axios.facebook({
          title: page.titolo,
          description: page.citta,
          image: this.$teras.bventUrl+page.id+'/'+page.imgcitta,
          file: page.id+'.html',
          filedir: '/www/www.biomedia.net/facebook/',
          urlrefresh:'https://next.biomedia.net/eventi/evento-home/'+page.id
          }).then(data => {

          console.log(data)
        }).catch(function (error) {
          console.log(error)
        })

        /*
        this.axios.html({site:'https://next.biomedia.net/eventi/evento-home/'+pageId}).then(data => {
          this.axios.saveFile(data,pageId+'.html','/www/www.biomedia.net/facebook/')
          console.log(data)
        }).catch(function (error) {
          console.log(error)
        })
        */
      },
      screenshot(){
        this.axios.png({site:'https://next.biomedia.net/eventi/evento-home/'+this.$route.params.id}).then(data => {
          this.pngFrom = data
          console.log(data)
        }).catch(function (error) {
          console.log(error)
        })
      }
  }
}
</script>


<style>
.social-vmenu {
  padding-top:34px !important;
}.social-vmenu a{
   display:block;
   padding:0 0 10px 30px;
}.social-vmenu-mobile {
  height:40px;
  padding-top:10px !important;
}.social-vmenu-mobile a{
   display:block;
   padding:0 10px 0 0;
   float:left;
}.social-vmenu-mobile a img{
  height:30px;


}.bolle{
   background-repeat: no-repeat;
   background-position:center center;
}
</style>



// WEBPACK FOOTER //
// src/components/Evento-home.vue